























import { defineComponent, computed } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import { ProductStatus, ReferencedProduct } from '@cstweb/site/types/product/productTypes'
import { PRODUCT_STATUS } from '@/common/utils/product/constants'
export default defineComponent({
  props: {
    alternateProducts: {
      type: Array as () => ReferencedProduct[],
      required: false,
      default: undefined,
    },
    currentProductStatus: {
      type: String as () => ProductStatus,
      required: false,
      default: undefined,
    },
  },
  setup(props) {
    const statusesToDisplayComponent = [
      PRODUCT_STATUS.DISCONTINUED,
      PRODUCT_STATUS.RELEASED_ON_HOLD,
      PRODUCT_STATUS.PENDING,
      PRODUCT_STATUS.PRE_DISCONTINUED,
    ] as ProductStatus[]
    const displayCondition =
      !isEmpty(props.alternateProducts) && statusesToDisplayComponent.includes(props.currentProductStatus)

    const title = computed(() => {
      if (props.currentProductStatus === PRODUCT_STATUS.PRE_DISCONTINUED) {
        return `The product you are currently viewing is going to be discontinued in the near future. To help you prepare for future experiments, we would like to suggest the following alternative(s).`
      } else if (
        props.currentProductStatus === PRODUCT_STATUS.DISCONTINUED ||
        props.currentProductStatus === PRODUCT_STATUS.PENDING
      ) {
        return `We recommend the following alternatives`
      }
    })

    return { displayCondition, title, PRODUCT_STATUS }
  },
})
